// 公用js，建议使用IIFE（立即执行函数）
;(function() {
  // 这里写代码
})()
